import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/solid';
import AuthHeader from './auth-header';
import NavLink from '../../shared/buttons/nav-link';
import { DEFAULT_STORE_URL } from '../../store/constants';

export type HeaderPropsType = {
  isAuthenticated: boolean;
  sticky: boolean;
};

function Header({ isAuthenticated, sticky }: HeaderPropsType) {
  const location = useLocation();
  const [isHidden, setIsHidden] = useState(true);
  const iconSize = 34;

  function isSelectedLink(linkHref: string): boolean {
    return location.pathname + location.search === linkHref;
  }

  return (
    <header data-testid='header' className={classNames({ sticky: sticky }, 'top-0 z-50 w-screen')}>
      <nav
        data-testid='header-nav'
        className='flex flex-wrap items-center justify-between bg-cyan-900 p-2'
      >
        <NavLink to='/' color='transparent' wrapperClassName='hidden md:block'>
          <p className='text-lg font-bold'>Med Moshaver</p>
        </NavLink>

        <AuthHeader className='mx-4 md:order-last' />

        <div className='mx-4 flex md:hidden'>
          <button id='hamburger' onClick={() => setIsHidden(isHidden => !isHidden)}>
            <Bars3Icon
              width={iconSize}
              height={iconSize}
              className={classNames(
                'toggle block',
                { hidden: !isHidden },
                'rounded-md border-2 border-yellow-500 stroke-current p-1 text-yellow-500'
              )}
            />
            <XMarkIcon
              width={iconSize}
              height={iconSize}
              className={classNames(
                'toggle block',
                { hidden: isHidden },
                'rounded-md border-2 border-yellow-500 stroke-current p-1 text-yellow-500'
              )}
            />
          </button>
        </div>

        <div
          className={classNames(
            'toggle',
            { hidden: isHidden },
            'text-bold mt-5 w-full text-right md:mt-0 md:flex md:w-auto',
            'border-t-2 border-blue-900 md:border-none'
          )}
        >
          {links
            .filter(link => !link.auth || isAuthenticated)
            .map(link => (
              <div
                key={link.id}
                className={classNames(
                  'w-100 block rounded-none border-t-2 border-yellow-500 md:rounded-lg',
                  'px-1 py-1 md:inline-block md:border-none',
                  { 'bg-cyan-800': isSelectedLink(link.href) }
                )}
              >
                <NavLink
                  to={link.href}
                  textSize='base'
                  color='transparent'
                  className={classNames({ 'font-medium': isSelectedLink(link.href) })}
                >
                  {link.name}
                </NavLink>
              </div>
            ))}
        </div>
      </nav>
    </header>
  );
}

const links = [
  { id: 1, name: 'خانه', href: '/', auth: false },
  { id: 2, name: 'آزمون‌ها', href: '/exams', auth: true },
  { id: 3, name: 'نتایج', href: '/results', auth: true },
  { id: 6, name: 'غلط‌نامه', href: '/student-questions', auth: true },
  { id: 4, name: 'فروشگاه', href: DEFAULT_STORE_URL, auth: true },
  { id: 5, name: 'سیر پیشرفت', href: '/progress/chart', auth: true }
];

export default Header;
